module.exports = __webpack_public_path__ + "static/media/Redoicon.db280efe.svg";